/*
 * Page routes list
 */

export const page_routes = {
  dashboard: "/",
  challenges: "/challenges",
  myDetail: "/my-detail",
  profile: "/profile",
  login: "/login",
  admin: "/admin/users",
  admin_dashboard: "/admin/dashboard",
  admin_skills: "/admin/skills",
  admin_teams: "/admin/teams",
  admin_events: "/admin/events",
  admin_vendors: "/admin/vendors",
  admin_navigation: "/admin/navigation",
  admin_edit_user: "/admin/users/edit/",
  user_surveys: "/surveys",
  admin_surveys: "/admin/surveys",
  add_surveys: "/admin/surveys/add",
  edit_surveys: "/admin/surveys/",
  submit_survey: "/survey/",
  survey_report: "/admin/survey-report",
  survey_report_analytics: "/admin/survey-report/:surveyId/analytics",
  recognition: "/recognition",
  rewards: "/rewards",
  rewardReports: "/reward/reports",
  reward_categories: "/reward/categories",
  reward_sub_categories: "/reward/sub-categories",
  redemtions: "/redemtions",
  awards: "/awards",
  moodHistory: "/mood-history",
  wellbeing_surveys: "/wellbeing-surveys",
  wellbeing_resources: "/wellbeing-resources",
  my_tools: "/my-tools",
  wellbeing_feedback: "/wellbeing-feedback",
  admin_wellbeing_feedback: "/admin/wellbeing-feedback",
  my_teams: "/my-teams",
  team_feed: "/teams/:teamId/feed",
  wellness_home: "/wellness",
  wellness_events: "/wellness/events",
  wellness_programs: "/wellness/programs",
  wellness_program_detail: "/wellness/programs/:programId",
  wellness_challenges: "/wellness/challenges",
  wellness_challenge_detail: "/wellness/challenges/:challengeId",
  admin_wellness_dashboard: "/admin/wellness",
  admin_goal_management: "/admin/wellness/goals",
  admin_wellness_programs: "/admin/wellness/programs",
  admin_wellness_challenges: "/admin/wellness/challenges",
  admin_wellness_challenge_create: "/admin/wellness/challenges/create",
  admin_wellness_challenge_detail: "/admin/wellness/challenges/:challengeId",
  admin_wellness_challenge_edit: "/admin/wellness/challenges/:challengeId/edit",
  admin_wellness_program_create: "/admin/wellness/programs/new",
  admin_wellness_program_detail: "/admin/wellness/programs/:programId",
  admin_wellness_program_edit: "/admin/wellness/programs/:programId/edit",
  admin_wellness_cohort_analytics: "/admin/wellness/cohorts/:cohortId/analytics",
  admin_wellness_correlation: "/admin/wellness/correlation",
  admin_wellness_support_requests: "/admin/wellness/support-requests",
  my_wellness_support_requests: "/wellness/support-requests",
  insufficientPermission: "/403",
};

export const page_names = {
  dashboard: { name: "Dashboard", path: page_routes.dashboard },
  challenges: { name: "Challenges", path: page_routes.challenges },
  myDetail: { name: "My Detail", path: page_routes.myDetail },
  profile: { name: "Profile", path: page_routes.profile },
  user_surveys: { name: "Surveys", path: page_routes.user_surveys },
  login: { name: "Login", path: page_routes.login },
  admin: { name: "Admin", path: page_routes.admin },
  admin_dashboard: { name: "Mood Dashboard", path: page_routes.admin_dashboard },
  admin_skills: { name: "Skills", path: page_routes.admin_skills },
  admin_events: { name: "Events", path: page_routes.admin_events },
  admin_vendors: { name: "Vendors", path: page_routes.admin_vendors },
  recognition: { name: "Recognition", path: page_routes.recognition },
  rewards: { name: "Rewards", path: page_routes.rewards },
  my_teams: { name: "My Teams", path: page_routes.my_teams },
  reward_categories: { name: "Reward Categories", path: page_routes.reward_categories },
  reward_sub_categories: { name: "Reward Sub-Categories", path: page_routes.reward_sub_categories },
  redemtions: { name: "Redemptions", path: page_routes.redemtions },
  awards: { name: "Awards", path: page_routes.awards },
  moodHistory: { name: "Mood History", path: page_routes.moodHistory },
  wellbeing_surveys: { name: "Wellbeing Surveys", path: page_routes.wellbeing_surveys },
  wellbeing_resources: { name: "Resource Library", path: page_routes.wellbeing_resources },
  my_tools: { name: "My Tools", path: page_routes.my_tools },
  wellbeing_feedback: { name: "Submit Feedback", path: page_routes.wellbeing_feedback },
  admin_wellbeing_feedback: { name: "Feedback Management", path: page_routes.admin_wellbeing_feedback },
  wellness_home: { name: "Wellness", path: page_routes.wellness_home },
  wellness_events: { name: "Wellness Events", path: page_routes.wellness_events },
  wellness_challenges: { name: "Wellness Challenges", path: page_routes.wellness_challenges },
  admin_wellness_dashboard: { name: "Wellness Dashboard", path: page_routes.admin_wellness_dashboard },
  admin_goal_management: { name: "Goal Management", path: page_routes.admin_goal_management },
  admin_wellness_programs: { name: "Programs", path: page_routes.admin_wellness_programs },
  admin_wellness_challenges: { name: "Challenges", path: page_routes.admin_wellness_challenges },
  admin_wellness_correlation: { name: "Correlation Analytics", path: page_routes.admin_wellness_correlation },
  admin_wellness_support_requests: { name: "Wellness Support Request", path: page_routes.admin_wellness_support_requests },
  my_wellness_support_requests: { name: "Wellness Support Request", path: page_routes.my_wellness_support_requests },
  insufficientPermission: { name: "Insufficient Permission", path: page_routes.insufficientPermission },
};